async function httprequesthandler(url) {
    const response = await fetch(url);
    const data = await response.json();
    return data;
  }
  
  // 👇️ named exports
  export {httprequesthandler};